<template>
    <ModeSwitcher
        ref="modeSwitcher"
        :main-mode-text="$t('create')"
        :create-mode-text="$t('creat_group_of_contracts')"
        :edit-mode-text="$t('edit_group_of_contracts')"
        class="pt-4"
        @reset="selectedContractGroupId = null"
    >
        <template v-slot:btn-block>
            <div class="full-width d-flex align-center flex-wrap">
                <v-spacer />
                <FilterStatusToggle v-model="activeFilter" @update:model-value="loadData" />
            </div>
        </template>
        <template v-slot:main-mode>
            <v-data-table
                :headers="useHeaders"
                :items="groupsOfContracts"
                :items-per-page-options="useTableOptions(groupsOfContracts.length)"
                :loading="isLoading"
                :items-length="groupsOfContracts.length"
                density="compact"
                class="elevation-1 table-server"
                must-sort
                fixed-header
            >
                <template v-slot:item.name="{item}">
                    <span class="text-link" @click="editSalesSettings(item.id)">
                        {{ item.name }}
                    </span>
                    <div v-if="item.defaultContractGroup" class="text-medium-emphasis">
                        ({{ $t('group_of_contracts_is_default') }})
                    </div>
                </template>
                <template v-slot:item.active="{item}">
                    {{ item.active ? $t('active') : $t('inactive') }}
                </template>
            </v-data-table>
        </template>
        <template v-slot:additional-mode>
            <GroupOfContractsForm
                :contract-group-id="selectedContractGroupId"
                @save="save()"
                @cancel="modeSwitcher.goToTable()"
            />
        </template>
    </ModeSwitcher>
</template>

<script setup lang="ts">
    import {useTableOptions} from '~/composables/helpers'

    const isLoading = ref<boolean>(false)
    const activeFilter = ref<boolean>(true)
    const groupsOfContracts = ref<any[]>([])
    const selectedContractGroupId = ref<number>()
    const modeSwitcher = ref(null)

    const {$api, $toast} = useNuxtApp()
    const {t} = useI18n()

    onMounted(async () => {
        await loadData()
    })

    async function loadData(): Promise<void> {
        isLoading.value = true
        try {
            const {contractGroups} = await $api.contractGroups.get({active: activeFilter.value})
            groupsOfContracts.value = contractGroups.sort((a, b) => a.name.localeCompare(b.name))
        } catch (e) {
            $toast.error(t('error_message.load_error'))
        } finally {
            isLoading.value = false
        }
    }

    const useHeaders = computed(() => {
        return [
            {title: t('name'), value: 'name', minWidth: '150px', sortable: true},
            {title: t('currency'), value: 'currency'},
            {title: t('status'), value: 'active', width: '140px'},
        ]
    })

    const editSalesSettings = (id: number): void => {
        selectedContractGroupId.value = id
        modeSwitcher.value.edit()
    }

    const save = async (): Promise<void> => {
        await loadData()
    }
</script>
